<template>
  <page-outline :title="$t('administration.user_add')">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <form-accordion :title="$t('administration.user_info')" :isTitleUpperCase="false">
          <div class="form-group">
          </div>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="login" isMandatory
                :inputLabel="$t('administration.identifier')" :placeholderValue="$t('administration.identifier')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="name" isMandatory
                :inputLabel="$t('administration.user_name')" :placeholderValue="$t('administration.user_name')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="email" isMandatory
                :inputLabel="$t('administration.email')" :placeholderValue="$t('administration.email')">
              </form-write-group-label-input>
            </b-col>
            <!-- <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="password" isMandatory
                :inputLabel="$t('administration.password')" :placeholderValue="$t('administration.password')">
              </form-write-group-label-input>
            </b-col> -->
            <b-col sm="6" class="form-group">
              <label for="password-field">{{ $t('administration.password') }} <span style="color: red">*</span></label>
              <div class="d-flex">
                <input v-model="password"
                  id="password-field"
                  class="form-control inputAccordionForm h-30px"
                  :type="passwordType"
                  :placeholder="$t('administration.password')"
                  required
                  aria-describedby="password-visibility-toggle">
                  <button type="button" class="icon icon-password mt-2 pt-1 icon-field"
                    :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    @click="switchPasswordType"
                    id="password-visibility-toggle"
                    :aria-label="isPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                    :aria-pressed="!isPasswordFieldHidden">
                  </button>
                </input>
              </div>
            </b-col>
          </b-row>
        </form-accordion>
        <br>
        <form-accordion :title="$t('administration.user_auth')" :isTitleUpperCase="false">
          <b-row class="justify-content-start">
            <b-col cols="3">
              <b-col cols="12" class="px-0">
                <label for="select-company-name">
                  {{ $t('administration.company_name') }}
                </label>
                <select id="select-company-name" class="form-control" v-model="idAccount" required
                  :aria-describedby="idAccount ? '' : 'company-help'"
                  :aria-label="$t('administration.company_name')">
                  <option value="" disabled>{{ $t('administration.select_company') }}</option>
                  <option v-for="(company, index) in allCompanies" :key="'filtered-profile-' + company.idAccount + '-' + index" :value="company.idAccount">
                    {{ company.name }}
                  </option>
                  <!--<option v-if="canAddAccount" value="new">Nouveau compte</option>-->
                </select>
                <small id="company-help" class="form-text text-muted" v-if="!idAccount">
                  {{ $t('administration.select_company_help') }}
                </small>
              </b-col>
            </b-col>
            <b-col cols="3" v-if="idAccount === 'new'">
              <b-col cols="12" class="px-0">
                <label>
                  Compte de rattachement
                </label>
                <select class="form-control" v-model="idAccountParent">
                  <option value="" disabled>Selectionner le compte de rattachement</option>
                  <option v-for="(company, index) in allCompanies" :key="'filtered-profile-' + company.idAccount + '-' + index" :value="company.idAccount">
                    {{ company.name }}
                  </option>
                </select>
              </b-col>
            </b-col>
            <b-col cols="3" v-if="idAccount === 'new'">
              <form-write-group-label-input v-model="accountName" isMandatory
                inputLabel="Nom du compte" placeholderValue="Nom du compte">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="3">
              <b-col cols="12" class="px-0">
                <label for="rights-profile">
                  {{ $t('administration.profile') }}
                </label>
                <select id="select-rights-profile" class="form-control" v-model="id_rights_profile"
                  :aria-label="$t('administration.profile')">
                  <option value="" disabled>{{ $t('administration.select_profile') }}</option>
                  <option v-for="(profile, index) in AllProfiles" :key="'filtered-profile-' + profile.id + '-' + index" :value="idAccount === 'new' ? profile.name : profile.id" :disabled="profile.disabled">
                    {{ profile.name }}
                  </option>
                </select>
              </b-col>
            </b-col>
          </b-row>
        </form-accordion>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="createUser">
      </app-button>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import AppButton from '@/components/common/AppButton.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'app-button': AppButton
  },
  props: ['idCompany'],
  computed: {
    canAddAccount () {
      return this.$engine.firstOn().rights.rightIs('usercompany_consult_filiale', true) || this.$engine.firstOn().rights.rightIs('usercompany_consult_admin', true) || this.$engine.firstOn().rights.rightIs('usercompany_add_admin', true) || this.$engine.firstOn().rights.rightIs('usercompany_add_filiale', true)
    },
    filteredProfiles () {
      return this.profiles.filter(elem => {
        return !elem.libelle.includes('_SRTP') && !elem.libelle.includes('_HRTP')
      })
    },
    AllProfiles () {
      let that = this
      if (this.idAccount === 'new') {
        // à remplacer par le résultat du get template
        // le droit pour le get template doit aussi conditionner le fait de pouvoir ajouter une nouvelle company
        let existingProfile = that.profiles.find(elem => elem.idAccount === that.idAccountParent)
        return this.templates.filter(template => {
          if (existingProfile) {
            return !existingProfile.profiles.map(profile => profile.name).includes(template.name)
          }
        })
      } else {
        let existingProfile = this.profiles.find(elem => elem.idAccount === that.idAccount)
        if (existingProfile) {
          return existingProfile.profiles
        } else {
          return [{
            id: 'AccountFirst',
            name: 'Veuillez choisir un compte en premier',
            disabled: true
          }]
        }
      }
    },
    allCompanies () {
      return this.profiles.map(profile => {
          return {
            idAccount: profile.idAccount,
            name: profile.name
          }
        })
    },
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    realProfileList () {
      let that = this
      const list = []
      for (const property in that.profiles) {
        const profile = that.profiles[property]
        list.push({
          tag: property,
          label: profile.libelle,
          state: profile.state,
          id: profile.id_rights_profile
        })
      }
      return list
    }
  },
  watch: {
    idAccount: function (val) {
      this.id_rights_profile = ''
    }
  },
  data () {
    return {
      active: '2',
      accountName: '',
      email: '',
      idAccount: '',
      idAccountParent: '',
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      templates: [],
      id_rights_profile: ''
    }
  },
  created () {
    let that = this
    this.$engine.firstOn().rights.fetchProfileTemplate()
    .then(resp => {
      that.templates = resp.templates
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    let userId = this.$engine.firstOn().user.get().id
    // console.log(this.$engine.firstOn().company)
    this.$engine.firstOn().company.profiles.forEach(profile => {
      let existingProfile = that.profiles.find(obj => obj.idAccount === profile.idAccount)
      if (!existingProfile) {
        that.profiles.push({
          idAccount: profile.idAccount,
          name: profile.nameAccount,
          profiles: [{
            id: profile.id_rights_profile,
            name: profile.libelle
          }]
        })
      } else if (!existingProfile.profiles.some(obj => obj.id === profile.id_rights_profile)) {
        existingProfile.profiles.push({
          id: profile.id_rights_profile,
          name: profile.libelle
        })
      }
    })
  },
  methods: {
    createUser () {
      let that = this
      if (this.formHasError()) {
        return
      }

      let account = ''
      let profile = ''
      if (this.idAccount === 'new') {
        account = {
          Identifier: this.accountName,
          Name: this.accountName,
          EmailReference: '*',
          Active: '1',
          IdParent: this.idAccountParent
        }
        profile = [this.id_rights_profile]
      } else {
        account = this.idAccount
        profile = parseInt(this.id_rights_profile)
      }
      let user = {
        Login: this.login,
        Name: this.name,
        Active: this.active,
        Email: this.email,
        Password: this.password
      }

      this.$engine.firstOn().usercompany.addUser(
        account,
        user,
        profile
      ).then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.user_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        //that.$bus.$emit('switch-selected-menu', '/usercompany/')
        if (that.idCompany && that.idCompany !== 'undefined') {
          loadPage(that, {url: '/detail/' + that.idCompany})
        } else {
          loadPage(that, {url: '/usercompany/'})
        }
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.user_addition_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    formHasError () {
      let that = this
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.email === undefined || this.email === '') {
        this.okMessageBox(this.$t('usercompany.missing_email'))
        return true
      }
      if (this.password === undefined || this.password === '') {
        this.okMessageBox(this.$t('usercompany.missing_password'))
        return true
      }
      if (this.id_rights_profile == '') {
        this.okMessageBox(this.$t('usercompany.missing_profile'))
        return true
      }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    goBack () {
      if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
        loadPage(this, {url: '/home/'})
      } else {
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
          loadPage(this, {url: '/home/'})
        } else {
          this.$f7.mainView.router.back()
        }
        this.$bus.$emit('router-back')
      }
    }
  }
}
</script>
